import React from "react"
import { Container, Row, Col } from "react-bootstrap"

const FooterComponent = () => {
  return (
    <footer
      className="py-4 mt-auto border-top"
      style={{ backgroundColor: "#1b3f87" }}
    >
      <Container fluid className="px-3 text-right">
        <Row className="d-flex justify-content-between">
          <Col md={4} className="d-flex align-items-center">
            <p className="text-light">© {new Date().getFullYear()} Global Testing Experts. All Rights Reserved.</p>
          </Col>
          <Col md={4} className="mb-4 mb-md-0" style={{ color: "white" }}>
            <h5 className="mb-3">Contact Us</h5>
            <p className="mb-2">
              <a
                href="mailto:support@globaltestingexperts.com"
                style={{ textDecoration: "none", color: "white" }}
              >
                support@globaltestingexperts.com
              </a>
            </p>
            <p className="mb-2">
              <a
                href="tel:+919910339902"
                style={{ textDecoration: "none", color: "white" }}
              >
                +91 99103 39902
              </a>
            </p>
            {/* <p className="mb-0">
              96, Sector 31, Faridabad - 121003,
              <br />
              Haryana, India
            </p> */}
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default FooterComponent
